export const ERPSeedless = "seedless";

export const ERPRJL = "rjl";
export const ERPUnity = "unity";
export const ERPOdoo = "odoo";
export const BrandingBottomHeight = 20;

export type InstalledModuleType =
  | "core"
  | "seedless"
  | "unity"
  | "price-change"
  | "product-approval"
  | "price-tier"
  | "order-addition"
  | "product-tag"
  | "support"
  | "order-import"
  | "order-export"
  | "shutdown"
  | "promotion"
  | "payment"
  | "substitution"
  | "credit-request"
  | "rjl"
  | "connector"
  | "nutrition"
  | "product-approval"
  | "van-sales-ordering"
  | "lead-time-override"
  | "product-related-group"
  | "waste"
  | "sage-50"
  | "special-price"
  | "discount"
  | "odoo";
